import React from 'react';
import ReactDOM from 'react-dom';

const modalRoot = document.getElementById('modal-root') || document.body;

const BlogsCircleSelect = ({
  blogsCircles,
  onSelectCircle,
  onClose,
}) => {
  return ReactDOM.createPortal(
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5))',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        overflow: 'hidden',
      }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        width: '90%',
        maxWidth: '700px',
        maxHeight: '80%',
        padding: '40px',
        overflowY: 'auto',
        boxSizing: 'border-box',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
      }}>
        <button
          style={{
            float: 'right',
            border: 'none',
            background: 'none',
            fontSize: '20px',
            cursor: 'pointer',
          }}
          onClick={onClose}
        >
          &times;
        </button>
        <h2 style={{
          textAlign: 'center',
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#333',
          marginBottom: '20px',
        }}>
          サークルを選択
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: '14px',
          color: '#666',
          marginBottom: '20px',
        }}>
          新しいブログを作成するサークルを選択してください
        </p>
        <div className="row">
          {blogsCircles.length > 0 ? (
            blogsCircles.map((circle) => (
              <div key={circle.id} className="col-6 mb-3">
                <div
                  className="card"
                  onClick={() => onSelectCircle(circle.id)}
                  style={{ 
                    cursor: 'pointer',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                    transition: 'transform 0.2s ease-in-out', 
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                  onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                  <img
                    src={circle.main_image_thumb || '/images/default_circle.png'}
                    alt={circle.name}
                    className="card-img-top"
                    style={{
                      maxHeight: '150px',
                      objectFit: 'cover',
                      borderTopLeftRadius: '12px',
                      borderTopRightRadius: '12px',
                    }}
                  />
                  <div className="card-body text-center text-fw-bold">{circle.name}</div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">サークルがありません。</p>
          )}
        </div>
      </div>
    </div>,
    modalRoot
  );
};

export default BlogsCircleSelect;

